import React, { useCallback, useState } from 'react';
import Accordion from 'components/UI/Accordion';
import List from 'components/UI/List';
import Link from 'components/UI/Link';
import Button from 'components/UI/Button';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import Card from './components/TileIcons/Card';
import { useTrans } from 'utils/localisation';

import * as styles from './TechnologiesGrid.module.scss';

function MobileContent({ tabsContent, showModal }) {
  const [activeSection, setActiveSection] = useState(null);
  const t = useTrans(['common']);

  const handleClick = useCallback(
    id => {
      if (activeSection === id) {
        setActiveSection(null);
      } else {
        setActiveSection(id);
      }
    },
    [activeSection],
  );

  return (
    <div className={styles.mobileContent}>
      {tabsContent.map(
        ({ id, tabLabel, title, description, list, link, tiles, withoutButton }, i) => (
          <React.Fragment key={`Fragment-${i}`}>
            {tabsContent.length > 1 ? (
              <Accordion
                key={`Mobile-${id}`}
                id={i}
                theme="withArrow"
                title={tabLabel}
                isOpened={activeSection === id || (i === 0 && activeSection === null)}
                onClick={() => handleClick(id)}
              >
                <div className={styles.expandPanelContent}>
                  <p>{description}</p>
                  <List
                    items={list}
                    size="lg"
                    className={styles.list}
                    theme="smallMarginChecked"
                    itemTag="p"
                  />
                  {tiles && (
                    <div className={styles.tilesWrapper}>
                      {tiles.map(tile => (
                        <Card key={tile.title} {...tile} />
                      ))}
                    </div>
                  )}
                  {link && (
                    <Link className={styles.link} href={link}>
                      {t('seeMore')}
                    </Link>
                  )}
                  {!withoutButton && (
                    <Button className={styles.button} onClick={showModal}>
                      {t('requestServices')}
                    </Button>
                  )}
                </div>
              </Accordion>
            ) : (
              <div key={`SingleMobile-${id}`}>
                <Title tag="h3">{title}</Title>
                <Subtitle className={styles.contentSubtitle}>{description}</Subtitle>
                <List items={list} size="md" className={styles.list} />
                {link && (
                  <Link className={styles.link} href={link}>
                    {t('seeMore')}
                  </Link>
                )}
                {!withoutButton && (
                  <Button className={styles.button} onClick={showModal} fullWidthMobile>
                    {t('requestServices')}
                  </Button>
                )}
              </div>
            )}
          </React.Fragment>
        ),
      )}
    </div>
  );
}

export default MobileContent;
